import { Ref, ref } from 'vue'

export default function useSelector<T = any>( update : (item: T) => void) {
  type Tuple = [Ref<T[]>, Ref<boolean>, (item: T) => void]

  const reativelist = ref<T[]>([])

  const isShow = ref<boolean>(false)

  const change = (item: T): void => {
    update(item)
  }

  return [reativelist, isShow, change] as Tuple
}
